import "./Loader.css";
import logo from "../../assets/logo.png";

export default function Loader({ inline = false, size = null }) {
  // Compact spinner mode — used wherever the loader must fit inside a
  // button, input, or other small UI element instead of a full section.
  if (size) {
    return (
      <span
        className="loader-spinner"
        style={{ width: size, height: size }}
        role="status"
        aria-label="Loading"
      />
    );
  }

  return (
    <div className={`loader${inline ? " loader--inline" : ""}`}>

      <img src={logo} className="logo" alt="logo"/>

      <div className="flight">

        <div className="cloud cloud1"></div>
        <div className="cloud cloud2"></div>

        <div className="pin left">📍</div>

        <svg
          className="path"
          viewBox="0 0 400 150"
        >
          <path
            id="curve"
            d="M30 110 Q200 10 370 110"
            fill="none"
            stroke="#58D3AE"
            strokeDasharray="8 8"
            strokeWidth="3"
          />
        </svg>

        <div className="plane">✈️</div>

        <div className="pin right">📍</div>

      </div>

      <h3>Searching the best travel deals...</h3>

      <div className="progress">
        <div className="fill"></div>
      </div>

      <p>Please wait...</p>

    </div>
  );
}